import { defineMessages, IntlFormatters } from "react-intl";

const levelMessages = defineMessages({
    "1": {
        id: "meta.level.1",
    },
    "2": {
        id: "meta.level.2",
    },
    "3": {
        id: "meta.level.3",
    },
    "4": {
        id: "meta.level.4",
    },
    "5": {
        id: "meta.level.5",
    },
    "6": {
        id: "meta.level.6",
    },
    "7": {
        id: "meta.level.7",
    },
    "8": {
        id: "meta.level.8",
    },
    "9": {
        id: "meta.level.9",
    },
    "10": {
        id: "meta.level.10",
    },
    "11": {
        id: "meta.level.11",
    },
    "12": {
        id: "meta.level.12",
    },
    "13": {
        id: "meta.level.13",
    },
    "14": {
        id: "meta.level.14",
    },
    "15": {
        id: "meta.level.15",
    },
});

export const levels = (fm: IntlFormatters["formatMessage"]) => [
    { value: 1, label: fm(levelMessages["1"]) },
    { value: 2, label: fm(levelMessages["2"]) },
    { value: 3, label: fm(levelMessages["3"]) },
    { value: 4, label: fm(levelMessages["4"]) },
    { value: 5, label: fm(levelMessages["5"]) },
    { value: 6, label: fm(levelMessages["6"]) },
    { value: 7, label: fm(levelMessages["7"]) },
    { value: 8, label: fm(levelMessages["8"]) },
    { value: 9, label: fm(levelMessages["9"]) },
    { value: 10, label: fm(levelMessages["10"]) },
    { value: 11, label: fm(levelMessages["11"]) },
    { value: 12, label: fm(levelMessages["12"]) },
    { value: 13, label: fm(levelMessages["13"]) },
    { value: 14, label: fm(levelMessages["14"]) },
    { value: 15, label: fm(levelMessages["15"]) },
];